import React from 'react';
import './App.scss';
import { Provider } from 'react-redux';
import store from './store';
import SiteStateFactory from './features/States/StateFactory';
import { Replay } from './features/Replay/Replay';
import { AdminTools } from './features/AdminTools/AdminTools';
import { DownloadPage } from './features/Downloads';
import {AppConnectionStatus} from './components/AppConnectionStatus';

function App() {
  let content = (() => {
    if (['/download', '/downlaod'].includes(window.location.pathname.replace(/\/+$/, ''))) return <DownloadPage />;
    const access = new URLSearchParams(window.location.search).get('access');

    if (access === undefined || access === null) {
      return <SiteStateFactory />;
    }

    switch (access) {
      case 'admin':
        return <AdminTools />;
      case 'replay':
        return <Replay />;
      default:
        return <SiteStateFactory />;
    }
  })();

  return <Provider store={store}>{content}<AppConnectionStatus/></Provider>;
}

export default App;
